export const ATHENA_URL = 'https://api.konik.ai/ws'
export const API_URL = 'https://api.konik.ai'
export const BILLING_URL = 'https://billing.comma.ai'
export const USERADMIN_URL = 'https://useradmin.konik.ai'
